module.exports = __webpack_public_path__ + "static/shalimar-demo-ea7c3255c399c8eb1ec8a48c012df28c.mp4";